import { createConfigExperiment, Experiment, getExperiment } from '@pegasus/abtesting';

export const PROJECT_ID = '1dae594d-b4df-416b-9d55-065e0ad138c7';
export const FB_MODAL_EXPERIMENT_ID = 'adeccb9b-a962-4952-8fc6-3bd854cba232';

export const CONTROL = 'fb_transition_off';
export const FB_MODAL_MANDATORY_FLOW = 'fb_transition_mandatory';
export const FB_OPTIONAL_FLOW = 'fb_transition_optional';

export const getVariantDetails = (experiment: Experiment) => {
    if (!experiment) {
        return {
            isVariant: false,
            isModalClosable: true,
        };
    }

    return {
        isVariant:
            experiment.variant === FB_MODAL_MANDATORY_FLOW ||
            experiment.variant === FB_OPTIONAL_FLOW,
        isModalClosable: experiment.variant === FB_OPTIONAL_FLOW,
    };
};

export const getDeprecationExperiment = (state: any): Experiment =>
    getExperiment(state, PROJECT_ID) as Experiment;

export default createConfigExperiment({
    projectId: PROJECT_ID,
    experimentId: FB_MODAL_EXPERIMENT_ID,
    variants: [CONTROL, FB_MODAL_MANDATORY_FLOW, FB_OPTIONAL_FLOW],
    context: {
        platform: 'web',
    },
});
